import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export const toCamelCase = (payload: any) => {
  return camelcaseKeys(payload, { deep: true });
};

export const toSnakeCase = (payload: any) => {
  return snakecaseKeys(payload, { deep: true });
};
